/**
 * Created by Jerker Nord on 2021-01-28.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TombstoneRip} from "../TombstoneRip";
import {TombstoneRipSound} from "../sound/TombstoneRipSound";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {TombstoneRipGameMode} from "./TombstoneRipGameMode";

export class TombstoneRipNormalBetPresentation implements FlowStatePresentation {

    private _normalStartDelay:number = 0.02;
    private _fastStartDelay:number = 0.01;

    constructor() {}

    public start(flowStateController:FlowStateController) {
        const tl = new TimelineLite({onComplete : () => flowStateController.finish()});
        tl.add(() => {
            // if(TombstoneRip.model.currentParsedData.nextMode === GameMode.NORMAL) {
            //     TombstoneRip.reel5Frame.endSuperFs();
            // }
            TombstoneRip.idle.stop();
            TombstoneRip.xBetController.buttonEnabled = false;
            TombstoneRip.playFSWin = false;
            TombstoneRip.superFsPop.reset();
            TombstoneRip.ways.reset();
            TombstoneRip.multiplier.reset();
            TombstoneRip.initialCountUp.remove();
            TombstoneRip.waysWon.remove();
            TombstoneRip.bigWinCountUp.remove();
            TombstoneRipSound.soundPlayer.playTrack({
                name : TombstoneRipSound.REELS_SPINNING,
                volume : 1
            });
        });
        TombstoneRip.reels.forEach((reel, reelId) => {
            tl.add(reel.startSpin(true, TombstoneRip.model.data.nextMode === TombstoneRipGameMode.FREESPIN_SUPER), (SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN) ? this._fastStartDelay : this._normalStartDelay) * reelId);
        });
    }
}